<template>
  <div class="">
    <div class="div-top-tip">订单类型</div>
    <el-tabs class="tab-box" v-model="activeName" @tab-click="handleClick(activeName,1)">
      <el-tab-pane label="待处理订单" name="first"></el-tab-pane>
      <el-tab-pane label="在途期货" name="second"></el-tab-pane>
      <el-tab-pane label="已完成订单" name="third"></el-tab-pane>
    </el-tabs>
    <div class="sce">
      <el-input v-model="input" placeholder="请输入合同编号" class="iiiii"></el-input>
      <el-button size="mini" class="nnnn" @click="search()">搜索</el-button>
    </div>
    <div class="order-list-table-box">
      <el-table class="order-list-table" ref="multipleTable" :data="showOrderList" tooltip-effect="dark"  height="450" border stripe style="width: 100%">
        <el-table-column prop="viewId" label="订单编号" width="100"></el-table-column>
        <el-table-column prop="payTime" label="下单时间" width="130">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.payTime) }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="totalMoney" label="总金额" width="80"></el-table-column>
        <el-table-column prop="goodsNumber" label="总数量" width="80"></el-table-column>
        <el-table-column prop="contractNo" label="合同编号" width="85"></el-table-column>
        <el-table-column prop="contactUser" label="收货人"></el-table-column>
        <el-table-column prop="unitProvinceCity" label="收货地址" :formatter="addressFormatter" width="220"></el-table-column>
        <el-table-column prop="phoneNumber" label="收货人电话" width="120"></el-table-column>
        <el-table-column prop="orderStatus" label="状态" :formatter="formatter" width="120"></el-table-column>
        <el-table-column prop="handle" label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <router-link :to="'/pc/order-detail?id='+scope.row.id">
              查看详情
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <p class="pagination">
        共{{total}}条
        <el-pagination
          layout="prev, pager, next"
          ref="pageination"
          :total="total"
          :page-size="5"
          @current-change="pageClick"
          class="pagina"
        ></el-pagination>
      </p>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/axios/index";
export default {
  data() {
    return {
      // tab默认选中值
      activeName: "first",
      // 切换tab展示的订单列表
      showOrderList: [
        {
          status: "未完成"
        }
      ],
      orderList0: [],
      orderList1: [],
      orderList2: [
        {
          orderId: 1,
          orderTime: 1540968664,
          totalFee: 111,
          totalSum: 1,
          name: "张三",
          address: "kaalallakskd",
          phone: "18900007544"
        }
      ],
      input:'',//搜索
      total: 0
    };
  },
  methods: {
    /* 
      状态改变值
        orderStatus字段,
          状态返回的名称都用订单状态
        -1取消订单
        1.待处理订单,
        10.在途期货,
        20.已完成订单 
    */
    formatter(row) {
      // console.log("row------------", row);
      if(row.orderStatus==1){
        row.orderStatus = '待处理订单'
      }else if(row.orderStatus==10){
        row.orderStatus = '在途期货'
      }else if(row.orderStatus==20){
        row.orderStatus = '已完成订单'
      }else if(row.orderStatus==-1){
        row.orderStatus = '取消订单'
      }
      return row.orderStatus
    },
      //搜索框
    search() {
      console.log(this.input);
      //待处理订单
        get("/stkorderinfo/getorderlist", { userRegisterId: this.userRID, orderFuzzy: this.input }).then(res => {
          console.log("搜索合同编号,res------", res.data.result);
          this.showOrderList = res.data.result;
        });
    },
    addressFormatter(row){
      return `${row.unitProvinceCity}${row.unitLocation}`
    },

    // 翻页
    pageClick(data) {
      console.log(data);
      console.log('118',this.activeName,data)
      //匹配订单状态
        this.handleClick(this.activeName ,data);
    },
    handleClick(name,page) {
      console.log("129", name,'=====',page);
      if (name== 'first') {
        //待处理订单
        get("/stkorderinfo/getorderlist", {page: page,size: 5, userRegisterId: this.userRID, orderStatus: 1 }).then(res => {
          console.log("待处理订单,res------", res.data.result);
          console.log('分页组件', this.$refs.pageination)
          this.showOrderList = res.data.result.pageData;
           this.$refs.pageination.internalCurrentPage = page;
          this.total = res.data.result.total;
        });
      } else if (name == 'second') {
        //在途期货
        get("/stkorderinfo/getorderlist", {page: page,size: 5, userRegisterId: this.userRID, orderStatus: 10 }).then(res => {
          console.log("在途期货订单,res------", res.data.result);
          console.log('分页组件', this.$refs.pageination)
          this.showOrderList = res.data.result.pageData;
           this.$refs.pageination.internalCurrentPage = page;
          this.total = res.data.result.total;
        });
      } else {
        get("/stkorderinfo/getorderlist", { page: page,size: 5,userRegisterId: this.userRID, orderStatus: 20 }).then(res => {
          console.log("已完成订单,res------", res.data.result);
          console.log('分页组件', this.$refs.pageination)
          this.showOrderList = res.data.result.pageData;
           this.$refs.pageination.internalCurrentPage = page;
          this.total = res.data.result.total;
        });
      }
    }
  },
  mounted() {},
  created() {
    this.userRID = JSON.parse(localStorage.getItem('stkMessage')).id
    get("/stkorderinfo/getorderlist", { page: 1,size: 5,userRegisterId: this.userRID, orderStatus: 1 }).then(res => {
      console.log("查询订单列表,res------", res.data.result.pageData);
      this.showOrderList = res.data.result.pageData;
      this.total = res.data.result.total;
    });
  }
};
</script>

<style lang="less" scoped>
.div-top-tip {
  margin-top: 30px;
}

.order-list-table-box {
  .common-shadow();
  .common-content-width();
  margin-bottom: 70px;
  padding: 20px;
}

/deep/.order-list-table {
  td {
    height: 50px;
    line-height: 50px;
  }
  th.is-leaf {
    border-bottom: 1px solid #eeeeee !important;
  }
  tr td:nth-of-type(3) {
    .cell {
      color: @color-orange !important;
    }
  }
}

.tab-box {
  margin-bottom: 36px;
  /deep/.is-top{
    width: 55%;
  }
}
.sce{
    float: left;
    margin-left: 66%;
    width: 300px;
    .iiiii{
      float: left;
      width: 200px;
      margin-top: -60px;
    }
    .nnnn{
      float: left;
      // width: 100px;
      margin-top: -60px;
      margin-left: 200px;
      height: 33px;
    }
}
/deep/.el-button[data-v-eaa97180]{
  min-width: 50px;
}
.pagination {
  position: relative;
  width: 24%;
  height: 4%;
  top: 2%;
  right: -45%;
  padding: 4px;
  margin: 1%;
  .pagina {
    position: absolute;
    top: 0%;
    left: 58%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderList.vue